import { GetterTree } from 'vuex';
import { Event, EventsState } from './models';
import { RootState } from '@/store';
import { EventForWidget } from '../components/EventsWidget/models';

export enum Getters {
    EVENTS = 'EVENTS',
    EVENTS_FOR_WIDGET = 'EVENTS_FOR_WIDGET',
    LOADED = 'LOADED',
    FETCHING = 'FETCHING',
  }

export const getters: GetterTree<EventsState, RootState> = {
  [Getters.EVENTS]({ events }): Event[] {
    return events;
  },

  [Getters.EVENTS_FOR_WIDGET]({ eventsForWidget }): EventForWidget[] {
    return eventsForWidget;
  },
};
